// The company the person is working in right now, for people who belong to more than one (a vendor of two builders). It is only a CHOICE: the backend reads
// it from the X-Company-Id header, checks it against the person's own live memberships and takes the role from the database, so a stale or edited value
// cannot reach a company the person does not belong to -- it is answered with 403 and the app falls back to the default company.
// localStorage is a per-browser convenience; it is never read as an access decision.
const SELECTED_COMPANY_KEY = 'selectedCompanyId';
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function getSelectedCompanyId(): string | null {
  try {
    const value = localStorage.getItem(SELECTED_COMPANY_KEY);
    return value && UUID_RE.test(value) ? value : null;
  } catch {
    return null;
  }
}

export function setSelectedCompanyId(companyId: string | null): void {
  try {
    if (companyId && UUID_RE.test(companyId)) localStorage.setItem(SELECTED_COMPANY_KEY, companyId);
    else localStorage.removeItem(SELECTED_COMPANY_KEY);
  } catch {
    /* storage unavailable: the default company is used */
  }
}

export const COMPANY_HEADER = 'X-Company-Id';
